export default __webpack_public_path__ + "static/media/Animale_mob_banner_3.a9742c27.png";